let config = {};

const env = process.env.REACT_APP_ENV;
// eslint-disable-next-line
console.log('@@@@@@ loading config for env:', env);

const videoPeelColors = {
  'p-50': '#eff6ff',
  'p-100': '#deebfe',
  'p-200': '#bfdafe',
  'p-300': '#93c3fd',
  'p-400': '#60a2fa',
  'p-500': '#3b7ef6',
  'p-600': '#255feb',
  'p-700': '#1d4ad8',
  'p-800': '#1e3daf',
  'p-900': '#1e388a',
  'p-950': '#172454',
};

const storyPortalColors = {
  'p-50': '#effaff',
  'p-100': '#def3ff',
  'p-200': '#b6eaff',
  'p-300': '#75dbff',
  'p-400': '#2ccaff',
  'p-500': '#00aeef',
  'p-600': '#0090d4',
  'p-700': '#0073ab',
  'p-800': '#00608d',
  'p-900': '#065074',
  'p-950': '#04334d',
};

switch (env) {
  case 'development':
    config = {
      apiHost: 'http://localhost:4000',
      colors: videoPeelColors,
      endpoints: {
        fileTypes: '/v1/options/file-types',
        publicCampaignInfo: '/v1/campaigns/',
        preSignVideoForS3: '/videos/s3/sign',
        campaignCount: '/campaign/count',
        campaignElementTypes: '/v1/campaigns/element-types',
        campaignSubmissions: '/v1/campaign-submissions',
        campaignResponseKeys: '/v1/campaign-response-keys',
        campaignList: '/v1/campaigns',
        campaignTemplateTypes: '/v1/campaign-templates',
        campaignTemplateTypesPurposes: '/v1/campaign-templates/type',
        campaignCreate: '/v1/campaigns',
        campaignDuplicate: '/v1/campaigns/duplicate',
        campaignDownloadResponsesCsv: '/v1/campaign-submissions/campaign',
        media: '/v1/media',
        amazonShare: '/videos/amazon',
        amazonShareStatus: '/v1/media',
        tags: '/v1/tags',
        preSignCampaignElementImageForS3: '/v1/campaign-elements/image/presign',
        authSso: '/organizations/sso',
        createPlugin: '/v1/plugins',
        pluginDetails: '/v1/plugins',
        preSignCepMediaSubmission: '/v1/media-submissions/cep',
        campaignSuccessPageEndpoint: '/v1/campaigns/success-page',
        terms: '/v1/terms',
      },
      stripe: {
        stripeKey: 'pk_test_e4q7MWpjoYvVfclU3T7DvEmX',
        name: 'VideoPeel', // the pop-in header title
        description: 'VideoPeel subscription payment', // the pop-in header subtitle
        buttonText: 'Sign Up',
        currency: 'USD',
        plans: {
          basic: {
            planId: 'free',
          },
          basicMonthly: {
            planId: 'price_1Mvi2gGddCycc7Zp51VoXF6A',
          },
          basicAnnually: {
            planId: 'price_1Mvi2gGddCycc7Zpabq9bfWS',
          },
          pro: {
            planId: 'pro',
            amount: 69,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00',
            },
          },
          premium: {
            // Used to reproduce https://videopeel.atlassian.net/browse/V2-260
            oldPlansId: ['premium-invalid'],
            planId: 'premium',
            amount: 399,
          },
          enterprise: {
            planId: 'enterprise',
            amount: 1000,
          },
          proAnnually: {
            planId: 'pro-annually',
            amount: 588,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00',
            },
          },
          premiumAnnually: {
            planId: 'premium-annually',
            amount: 2988,
          },
          enterpriseAnnually: {
            planId: 'enterprise-annually',
            amount: 10000,
          },
          enterpriseMonthly: {
            planId: 'enterprise-monthly',
            amount: 2000,
          },
          amazonBasicMonthly: {
            planId: 'price_1H2rZ0GddCycc7ZpodlEwUwa',
            amount: 69,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonBasicAnnual: {
            planId: 'price_1H2raJGddCycc7ZpqfOpsGYu',
            amount: 588,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonPremiumMonthly: {
            planId: 'price_1H2raqGddCycc7ZpYcJIat72',
            amount: 249,
          },
          amazonPremiumAnnual: {
            planId: 'price_1H2rbKGddCycc7Zp87Gy3ov8',
            amount: 2388,
          },
        },
      },
      GoogleAuth: {
        clientId: '271699968826-o9prronf2ted8j5ve4nn4bi2valkoq6o.apps.googleusercontent.com',
      },
      AWS: {
        SiteAssets: 'https://s3.amazonaws.com/videopeel-development',
        cdnUrl: `https://${process.env.OUTPUT_BUCKET}.s3.amazonaws.com`,
        S3bucket: 'https://s3.amazonaws.com/videopeel-development',
        GateWayURL: 'https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/stage/process-video',
        fileUploadUrl: process.env.FILE_UPLOAD_APIGATEWAY
          ? `${process.env.FILE_UPLOAD_APIGATEWAY}/files`
          : 'https://ley3aeio81.execute-api.us-east-1.amazonaws.com/dev/files',
        attachmentsCloudfrontUrl:
          process.env.CLOUDFRONT_URL || 'https://d111yeai6xpcar.cloudfront.net',
        S3bucketName: process.env.OUTPUT_BUCKET,
        fileUploadApiGateway: process.env.FILE_UPLOAD_APIGATEWAY,
      },
      FACEBOOK: {
        isEnabled: false, // V2-425 needs to be false for unit tests :grimacing:
        appId: '2457067157728402',
      },
      trialPeriod: {
        days: 7,
      },
      projectId: 257755,
      projectKey: '913f712f693843d510f39b4293af316f',
      VideoPeelSupportLink: 'https://calendly.com/derek-217/vp-account-update',
      campaignIDs: ['k64bbg52', 'k7dmg3hc', 'k7dop0ti'],
      intercomAppID: 'uhfhkkts',
      campaignLimit: 2,
      errorBoundary: false,
      startVideoLink: 'https://www.youtube.com/embed/m5E9Q5cdD6E',
      pluginURL: `https://${process.env.OUTPUT_BUCKET}.s3.amazonaws.com`,
      baseAppDomain: '', // do not add anything here for development env, otherwise redirect rules for custom domains will start applying
      appAlternateDomain: '',
      subdomainBaseUrl: '',
      perMonthVideo: 50,
      googleAnalyticsId: 'UA-112744776-3',
      nextGenMinimalCampaignTypeEnabled: true,
      mediaRecordsPerPageDefault: 25,
      campaignRecordsPerPageDefault: 25,
      maxCampaignsPerAccount: 50,
      pluginsV2Enabled: true,
      signInV2Enabled: true,
      pluginFontSizeEnabled: false,
      promoCodeEnabled: true,
      helpCenterLink: 'https://learn.videopeel.com/en/',
      captionHelpLink: 'https://learn.videopeel.com/en/articles/14485153-automated-captions',
      translationHelpLink: 'https://learn.videopeel.com/en/articles/14485272-automated-translations',
      rewardsHelpLink: 'https://learn.videopeel.com/en/articles/13403305-automated-rewards',
      contactSalesLink: 'https://www.videopeel.com',
      openMediaInPreviewModal: true,
      isAwinTrackingEnabled: false,
      vcpLiveExampleLink: 'https://app.videopeel.com/vc/cdtgx88l',
      vcpShareEnabled: false,
      termsAndConditionsLink: 'https://www.videopeel.com/utility/terms',
      privacyPolicyLink: 'https://www.videopeel.com/privacypolicy',
      companyName: 'ProductPeel, Inc.',
      companyWebsite: 'https://www.videopeel.com',
      shareVideosLinkUrl: 'http://localhost:3000',
      signupLink: '/signup/free',
      helpLink: 'https://learn.videopeel.com/en/',
      inactivityLimit: 45 * 60 * 1000,
      modalTimeout: 2 * 60 * 1000,
    };
    break;

  case 'staging':
    config = {
      apiHost: 'https://stagingapi.videopeel.com',
      colors: videoPeelColors,
      endpoints: {
        fileTypes: '/v1/options/file-types',
        publicCampaignInfo: '/v1/campaigns/',
        preSignVideoForS3: '/videos/s3/sign',
        campaignCount: '/campaign/count',
        campaignElementTypes: '/v1/campaigns/element-types',
        campaignSubmissions: '/v1/campaign-submissions',
        campaignResponseKeys: '/v1/campaign-response-keys',
        campaignList: '/v1/campaigns',
        campaignTemplateTypes: '/v1/campaign-templates',
        campaignCreate: '/v1/campaigns',
        campaignDuplicate: '/v1/campaigns/duplicate',
        campaignDownloadResponsesCsv: '/v1/campaign-submissions/campaign',
        media: '/v1/media',
        amazonShare: '/videos/amazon',
        amazonShareStatus: '/v1/media',
        tags: '/v1/tags',
        preSignCampaignElementImageForS3: '/v1/campaign-elements/image/presign',
        authSso: '/organizations/sso',
        createPlugin: '/v1/plugins',
        pluginDetails: '/v1/plugins',
        preSignCepMediaSubmission: '/v1/media-submissions/cep',
        campaignSuccessPageEndpoint: '/v1/campaigns/success-page',
        terms: '/v1/terms',
      },
      stripe: {
        stripeKey: 'pk_test_e4q7MWpjoYvVfclU3T7DvEmX',
        name: 'VideoPeel', // the pop-in header title
        description: 'VideoPeel subscription payment', // the pop-in header subtitle
        buttonText: 'Sign Up',
        currency: 'USD',
        plans: {
          basic: {
            planId: 'free',
          },
          basicMonthly: {
            planId: 'price_1Mvi2gGddCycc7Zp51VoXF6A',
          },
          basicAnnually: {
            planId: 'price_1Mvi2gGddCycc7Zpabq9bfWS',
          },
          pro: {
            planId: 'pro',
            amount: 69,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00',
            },
          },
          premium: {
            oldPlansId: ['plan_Gc≈gYRz69NITi3X', 'plan_FHjyi8YjF6DOTL', 'plan_H3dvqapPNg3rYY', 'prod_QcMsMLWEcOAWpz'],
            planId: 'price_1TH1GKGddCycc7ZpzFhtKVJ6',
            amount: 149,
          },
          enterprise: {
            planId: 'enterprise',
            amount: 1000,
          },
          proAnnually: {
            planId: 'pro-annually',
            amount: 588,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00',
            },
          },
          premiumAnnually: {
            oldPlansId: ['prod_QcMxWamRWqW52V'],
            planId: 'price_1TH1FnGddCycc7ZpeBLp2rLc',
            amount: 1188,
          },
          enterpriseAnnually: {
            planId: 'enterprise-annually',
            amount: 10000,
          },
          enterpriseMonthly: {
            planId: 'enterprise-monthly',
            amount: 2000,
          },
          amazonBasicMonthly: {
            planId: 'price_1H2rZ0GddCycc7ZpodlEwUwa',
            amount: 69,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonBasicAnnual: {
            planId: 'price_1H2raJGddCycc7ZpqfOpsGYu',
            amount: 588,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonPremiumMonthly: {
            planId: 'price_1H2raqGddCycc7ZpYcJIat72',
            amount: 249,
          },
          amazonPremiumAnnual: {
            planId: 'price_1H2rbKGddCycc7Zp87Gy3ov8',
            amount: 2388,
          },
        },
      },
      GoogleAuth: {
        clientId: '271699968826-n516e2dad90ll393c7v5o25q740t8j6l.apps.googleusercontent.com',
      },
      AWS: {
        SiteAssets: 'https://d21kaqp8o0oh0c.cloudfront.net',
        cdnUrl: 'https://d21kaqp8o0oh0c.cloudfront.net',
        S3bucket: 'https://s3.amazonaws.com/videopeel-development',
        GateWayURL: 'https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/stage/process-video',
        fileUploadUrl: 'https://u2ipod3vsf.execute-api.us-east-1.amazonaws.com/staging/files',
        attachmentsCloudfrontUrl: 'https://d3rn0qvp5ksu2g.cloudfront.net',
        S3bucketName: 'videopeel-development',
        fileUploadApiGateway: 'https://u2ipod3vsf.execute-api.us-east-1.amazonaws.com/staging',
      },
      FACEBOOK: {
        isEnabled: true,
        appId: '2457067157728402',
      },
      trialPeriod: {
        days: 7,
      },
      projectId: 257755,
      projectKey: '913f712f693843d510f39b4293af316f',
      VideoPeelSupportLink: 'https://calendly.com/derek-217/vp-account-update',
      campaignIDs: ['k64bbg52', 'k7dmg3hc', 'k7dop0ti'],
      intercomAppID: 'uhfhkkts',
      campaignLimit: 2,
      errorBoundary: false,
      startVideoLink: 'https://www.youtube.com/embed/m5E9Q5cdD6E',
      pluginURL: 'https://pluginstaging.videopeel.com',
      baseAppDomain: 'staging.videopeel.com',
      appAlternateDomain: 'atela.dev',
      subdomainBaseUrl: 'staging.videopeel.com',
      perMonthVideo: 50,
      googleAnalyticsId: 'UA-112744776-3',
      nextGenMinimalCampaignTypeEnabled: true,
      mediaRecordsPerPageDefault: 25,
      campaignRecordsPerPageDefault: 25,
      maxCampaignsPerAccount: 50,
      pluginsV2Enabled: true,
      signInV2Enabled: true,
      pluginFontSizeEnabled: false,
      promoCodeEnabled: true,
      helpCenterLink: 'https://learn.videopeel.com/en/',
      captionHelpLink: 'https://learn.videopeel.com/en/articles/14485153-automated-captions',
      translationHelpLink: 'https://learn.videopeel.com/en/articles/14485272-automated-translations',
      rewardsHelpLink: 'https://learn.videopeel.com/en/articles/13403305-automated-rewards',
      contactSalesLink: 'https://www.videopeel.com',
      openMediaInPreviewModal: true,
      isAwinTrackingEnabled: false,
      vcpLiveExampleLink: 'https://app.videopeel.com/vc/cdtgx88l',
      vcpShareEnabled: false,
      termsAndConditionsLink: 'https://www.videopeel.com/utility/terms',
      privacyPolicyLink: 'https://www.videopeel.com/privacypolicy',
      companyName: 'ProductPeel, Inc.',
      companyWebsite: 'https://www.videopeel.com',
      shareVideosLinkUrl: 'https://app.videopeel.com',
      signupLink: '/signup/free',
      helpLink: 'https://learn.videopeel.com/en/',
      inactivityLimit: 45 * 60 * 1000,
      modalTimeout: 2 * 60 * 1000,
    };
    break;

  case 'production':
    config = {
      apiHost: 'https://api.videopeel.com',
      colors: videoPeelColors,
      endpoints: {
        fileTypes: '/v1/options/file-types',
        publicCampaignInfo: '/v1/campaigns/',
        preSignVideoForS3: '/videos/s3/sign',
        campaignCount: '/campaign/count',
        campaignElementTypes: '/v1/campaigns/element-types',
        campaignSubmissions: '/v1/campaign-submissions',
        campaignResponseKeys: '/v1/campaign-response-keys',
        campaignList: '/v1/campaigns',
        campaignTemplateTypes: '/v1/campaign-templates',
        campaignCreate: '/v1/campaigns',
        campaignDuplicate: '/v1/campaigns/duplicate',
        campaignDownloadResponsesCsv: '/v1/campaign-submissions/campaign',
        media: '/v1/media',
        amazonShare: '/videos/amazon',
        amazonShareStatus: '/v1/media',
        tags: '/v1/tags',
        preSignCampaignElementImageForS3: '/v1/campaign-elements/image/presign',
        authSso: '/organizations/sso',
        createPlugin: '/v1/plugins',
        pluginDetails: '/v1/plugins',
        preSignCepMediaSubmission: '/v1/media-submissions/cep',
        campaignSuccessPageEndpoint: '/v1/campaigns/success-page',
        terms: '/v1/terms',
      },
      stripe: {
        stripeKey:
          'pk_live_51BM0KYGddCycc7ZpiQdMQxnF5jyMOz6UfPf8oWrRsWeCjuGLxPC5HlI0M05ZVPEWEOmd2g6OL9GnJNbsQBGAC5eW00uclHL9Xy',
        name: 'VideoPeel', // the pop-in header title
        description: 'VideoPeel subscription payment', // the pop-in header subtitle
        buttonText: 'Sign Up',
        currency: 'USD',
        plans: {
          basic: {
            planId: 'free',
          },
          basicMonthly: {
            planId: 'price_1Mw1C3GddCycc7Zp9KjTNRaI',
          },
          basicAnnually: {
            planId: 'price_1N8WdpGddCycc7Zp4uUDj8Wk',
          },
          pro: {
            oldPlansId: ['plan_Eo9RGo1vW6jr5x'],
            planId: 'plan_GcgUejNNXClIwi',
            amount: 69,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00',
            },
          },
          premium: {
            oldPlansId: ['plan_Gc≈gYRz69NITi3X', 'plan_FHjyi8YjF6DOTL', 'plan_H3dvqapPNg3rYY', 'price_1PgWWPGddCycc7ZpmgDc7zOF'],
            planId: 'price_1TH1CWGddCycc7Zp2XjAYHOW',
            amount: 149,
          },
          enterprise: {
            planId: 'plan_H3e1Q7cBYJZp0z',
            amount: 1000,
          },
          proAnnually: {
            planId: 'plan_H3e9KsEYNAzD1K',
            amount: 588,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00',
            },
          },
          premiumAnnually: {
            oldPlansId: ['plan_H3eCryd5JCaxgE', 'price_1PgWYZGddCycc7ZpomydItz8'],
            planId: 'price_1TH1B7GddCycc7Zpa8zUbLB5',
            amount: 1188,
          },
          enterpriseAnnually: {
            planId: 'plan_H3eLFlACpGpOnb',
            amount: 10000,
          },
          enterpriseMonthly: {
            planId: 'price_1HJmgnGddCycc7ZpXc3w39r9',
            amount: 2000,
          },
          amazonBasicMonthly: {
            planId: 'price_1H2r02GddCycc7ZpEoeJBhGu',
            amount: 69,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonBasicAnnual: {
            planId: 'price_1H2r2jGddCycc7ZpwTmAvvzm',
            amount: 588,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonPremiumMonthly: {
            planId: 'price_1H2r3qGddCycc7ZpPdUIMciS',
            amount: 249,
          },
          amazonPremiumAnnual: {
            planId: 'price_1H2r56GddCycc7Zp0JXIpJTX',
            amount: 2388,
          },
          premiumMonthlyLegacy: {
            oldPlansId: ['plan_GcgYRz69NITi3X', 'plan_FHjyi8YjF6DOTL'],
            planId: 'plan_H3dvqapPNg3rYY',
            amount: 399,
          },
          premiumAnnuallyLegacy: {
            planId: 'plan_H3eCryd5JCaxgE',
            amount: 2988,
          },
        },
      },
      GoogleAuth: {
        clientId: '271699968826-n516e2dad90ll393c7v5o25q740t8j6l.apps.googleusercontent.com',
      },
      AWS: {
        SiteAssets: 'https://d2fr8icwxgw12b.cloudfront.net',
        cdnUrl: 'https://d2fr8icwxgw12b.cloudfront.net',
        S3bucket: 'https://s3.amazonaws.com/videopeel-production',
        GateWayURL: 'https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/prod/process-video',
        fileUploadUrl: 'https://gd4215x8y7.execute-api.us-east-1.amazonaws.com/prod/files',
        attachmentsCloudfrontUrl: 'https://d3pxzwt5386y7s.cloudfront.net',
        S3bucketName: 'videopeel-production',
        fileUploadApiGateway: 'https://gd4215x8y7.execute-api.us-east-1.amazonaws.com/prod',
      },
      FACEBOOK: {
        isEnabled: true,
        appId: '454904778263732',
      },
      trialPeriod: {
        days: 7,
      },
      projectId: 257755,
      projectKey: '913f712f693843d510f39b4293af316f',
      VideoPeelSupportLink: 'https://calendly.com/derek-217/vp-account-update',
      campaignIDs: ['k64bbg52', 'k7dmg3hc', 'k7dop0ti'],
      intercomAppID: 'uhfhkkts',
      campaignLimit: 2,
      errorBoundary: true,
      startVideoLink: 'https://www.youtube.com/embed/m5E9Q5cdD6E',
      pluginURL: 'https://plugin.videopeel.com',
      baseAppDomain: 'app.videopeel.com',
      appAlternateDomain: 'storyportal.app',
      subdomainBaseUrl: 'videopeel.com',
      perMonthVideo: 50,
      googleAnalyticsId: 'UA-112744776-2',
      nextGenMinimalCampaignTypeEnabled: true,
      mediaRecordsPerPageDefault: 25,
      campaignRecordsPerPageDefault: 25,
      maxCampaignsPerAccount: 50,
      pluginsV2Enabled: true,
      signInV2Enabled: true,
      pluginFontSizeEnabled: false,
      promoCodeEnabled: true,
      helpCenterLink: 'https://learn.videopeel.com/en/',
      captionHelpLink: 'https://learn.videopeel.com/en/articles/14485153-automated-captions',
      translationHelpLink: 'https://learn.videopeel.com/en/articles/14485272-automated-translations',
      rewardsHelpLink: 'https://learn.videopeel.com/en/articles/13403305-automated-rewards',
      contactSalesLink: 'https://meetings.hubspot.com/patrick-tedjamulia',
      openMediaInPreviewModal: true,
      isAwinTrackingEnabled: true,
      vcpLiveExampleLink: 'https://app.videopeel.com/vc/cdtgx88l',
      vcpShareEnabled: false,
      termsAndConditionsLink: 'https://www.videopeel.com/utility/terms',
      privacyPolicyLink: 'https://www.videopeel.com/privacypolicy',
      companyName: 'ProductPeel, Inc.',
      companyWebsite: 'https://www.videopeel.com',
      shareVideosLinkUrl: 'https://app.videopeel.com',
      signupLink: '/signup/free',
      helpLink: 'https://learn.videopeel.com/en/',
      inactivityLimit: 45 * 60 * 1000,
      modalTimeout: 2 * 60 * 1000,
    };
    break;

  case 'atela':
    config = {
      apiHost: 'https://api.atela.dev',
      colors: storyPortalColors,
      endpoints: {
        fileTypes: '/v1/options/file-types',
        publicCampaignInfo: '/v1/campaigns/',
        preSignVideoForS3: '/videos/s3/sign',
        campaignCount: '/campaign/count',
        campaignElementTypes: '/v1/campaigns/element-types',
        campaignSubmissions: '/v1/campaign-submissions',
        campaignResponseKeys: '/v1/campaign-response-keys',
        campaignList: '/v1/campaigns',
        campaignTemplateTypes: '/v1/campaign-templates',
        campaignCreate: '/v1/campaigns',
        campaignDuplicate: '/v1/campaigns/duplicate',
        campaignDownloadResponsesCsv: '/v1/campaign-submissions/campaign',
        media: '/v1/media',
        amazonShare: '/videos/amazon',
        amazonShareStatus: '/v1/media',
        tags: '/v1/tags',
        preSignCampaignElementImageForS3: '/v1/campaign-elements/image/presign',
        authSso: '/organizations/sso',
        createPlugin: '/v1/plugins',
        pluginDetails: '/v1/plugins',
        preSignCepMediaSubmission: '/v1/media-submissions/cep',
        campaignSuccessPageEndpoint: '/v1/campaigns/success-page',
        terms: '/v1/terms',
      },
      stripe: {
        stripeKey: 'pk_test_e4q7MWpjoYvVfclU3T7DvEmX',
        name: 'VideoPeel', // the pop-in header title
        description: 'VideoPeel subscription payment', // the pop-in header subtitle
        buttonText: 'Sign Up',
        currency: 'USD',
        plans: {
          basic: {
            planId: 'free',
          },
          basicMonthly: {
            planId: 'price_1Mvi2gGddCycc7Zp51VoXF6A',
          },
          basicAnnually: {
            planId: 'price_1Mvi2gGddCycc7Zpabq9bfWS',
          },
          pro: {
            planId: 'pro',
            amount: 69,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00',
            },
          },
          premium: {
            // Used to reproduce https://videopeel.atlassian.net/browse/V2-260
            oldPlansId: ['premium-invalid'],
            planId: 'premium',
            amount: 399,
          },
          enterprise: {
            planId: 'enterprise',
            amount: 1000,
          },
          proAnnually: {
            planId: 'pro-annually',
            amount: 588,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00',
            },
          },
          premiumAnnually: {
            planId: 'premium-annually',
            amount: 2988,
          },
          enterpriseAnnually: {
            planId: 'enterprise-annually',
            amount: 10000,
          },
          enterpriseMonthly: {
            planId: 'enterprise-monthly',
            amount: 2000,
          },
          amazonBasicMonthly: {
            planId: 'price_1H2rZ0GddCycc7ZpodlEwUwa',
            amount: 69,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonBasicAnnual: {
            planId: 'price_1H2raJGddCycc7ZpqfOpsGYu',
            amount: 588,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonPremiumMonthly: {
            planId: 'price_1H2raqGddCycc7ZpYcJIat72',
            amount: 249,
          },
          amazonPremiumAnnual: {
            planId: 'price_1H2rbKGddCycc7Zp87Gy3ov8',
            amount: 2388,
          },
        },
      },
      GoogleAuth: {
        clientId: '271699968826-n516e2dad90ll393c7v5o25q740t8j6l.apps.googleusercontent.com',
      },
      AWS: {
        SiteAssets: 'https://d21kaqp8o0oh0c.cloudfront.net',
        cdnUrl: 'https://d21kaqp8o0oh0c.cloudfront.net',
        S3bucket: 'https://s3.amazonaws.com/videopeel-development',
        GateWayURL: 'https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/stage/process-video',
        fileUploadUrl: 'https://u2ipod3vsf.execute-api.us-east-1.amazonaws.com/staging/files',
        attachmentsCloudfrontUrl: 'https://d3rn0qvp5ksu2g.cloudfront.net',
        S3bucketName: 'videopeel-development',
        fileUploadApiGateway: 'https://u2ipod3vsf.execute-api.us-east-1.amazonaws.com/staging', // same as staging
      },
      FACEBOOK: {
        isEnabled: true,
        appId: '2457067157728402',
      },
      trialPeriod: {
        days: 7,
      },
      projectId: 257755,
      projectKey: '913f712f693843d510f39b4293af316f',
      VideoPeelSupportLink: 'https://calendly.com/derek-217/vp-account-update',
      campaignIDs: ['k64bbg52', 'k7dmg3hc', 'k7dop0ti'],
      intercomAppID: 'uhfhkkts',
      campaignLimit: 2,
      errorBoundary: false,
      startVideoLink: 'https://www.youtube.com/embed/m5E9Q5cdD6E',
      pluginURL: 'https://plugin.atela.dev',
      baseAppDomain: 'atela.dev',
      appAlternateDomain: 'atela.dev',
      subdomainBaseUrl: 'atela.dev',
      perMonthVideo: 50,
      googleAnalyticsId: 'UA-112744776-3',
      nextGenMinimalCampaignTypeEnabled: true,
      mediaRecordsPerPageDefault: 25,
      campaignRecordsPerPageDefault: 25,
      maxCampaignsPerAccount: 50,
      pluginsV2Enabled: true,
      signInV2Enabled: true,
      pluginFontSizeEnabled: false,
      promoCodeEnabled: true,
      helpCenterLink: 'https://learn.videopeel.com/en/',
      captionHelpLink: 'https://learn.videopeel.com/en/articles/14485153-automated-captions',
      translationHelpLink: 'https://learn.videopeel.com/en/articles/14485272-automated-translations',
      rewardsHelpLink: 'https://learn.videopeel.com/en/articles/13403305-automated-rewards',
      contactSalesLink: 'https://www.videopeel.com',
      openMediaInPreviewModal: true,
      isAwinTrackingEnabled: false,
      vcpLiveExampleLink: 'https://app.videopeel.com/vc/cdtgx88l',
      vcpShareEnabled: false,
      termsAndConditionsLink: 'https://storyportal-assets.s3.amazonaws.com/StoryPortal+Terms.pdf',
      privacyPolicyLink: 'https://storyportal-assets.s3.amazonaws.com/StoryPortal+Privacy.pdf',
      companyName: 'StoryPortal',
      companyWebsite: 'https://www.videopeel.com',
      shareVideosLinkUrl: 'https://app.videopeel.com',
      signupLink: null,
      helpLink: null,
      inactivityLimit: 45 * 60 * 1000,
      modalTimeout: 2 * 60 * 1000,
    };
    break;

  case 'storyportal':
    config = {
      apiHost: 'https://api.storyportal.app',
      colors: storyPortalColors,
      endpoints: {
        fileTypes: '/v1/options/file-types',
        publicCampaignInfo: '/v1/campaigns/',
        preSignVideoForS3: '/videos/s3/sign',
        campaignCount: '/campaign/count',
        campaignElementTypes: '/v1/campaigns/element-types',
        campaignSubmissions: '/v1/campaign-submissions',
        campaignResponseKeys: '/v1/campaign-response-keys',
        campaignList: '/v1/campaigns',
        campaignTemplateTypes: '/v1/campaign-templates',
        campaignCreate: '/v1/campaigns',
        campaignDuplicate: '/v1/campaigns/duplicate',
        campaignDownloadResponsesCsv: '/v1/campaign-submissions/campaign',
        media: '/v1/media',
        amazonShare: '/videos/amazon',
        amazonShareStatus: '/v1/media',
        tags: '/v1/tags',
        preSignCampaignElementImageForS3: '/v1/campaign-elements/image/presign',
        authSso: '/organizations/sso',
        createPlugin: '/v1/plugins',
        pluginDetails: '/v1/plugins',
        preSignCepMediaSubmission: '/v1/media-submissions/cep',
        campaignSuccessPageEndpoint: '/v1/campaigns/success-page',
        terms: '/v1/terms',
      },
      stripe: {
        stripeKey: 'pk_test_e4q7MWpjoYvVfclU3T7DvEmX',
        name: 'VideoPeel', // the pop-in header title
        description: 'VideoPeel subscription payment', // the pop-in header subtitle
        buttonText: 'Sign Up',
        currency: 'USD',
        plans: {
          basic: {
            planId: 'free',
          },
          basicMonthly: {
            planId: 'price_1Mvi2gGddCycc7Zp51VoXF6A',
          },
          basicAnnually: {
            planId: 'price_1Mvi2gGddCycc7Zpabq9bfWS',
          },
          pro: {
            planId: 'pro',
            amount: 69,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00',
            },
          },
          premium: {
            // Used to reproduce https://videopeel.atlassian.net/browse/V2-260
            oldPlansId: ['premium-invalid'],
            planId: 'premium',
            amount: 399,
          },
          enterprise: {
            planId: 'enterprise',
            amount: 1000,
          },
          proAnnually: {
            planId: 'pro-annually',
            amount: 588,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00',
            },
          },
          premiumAnnually: {
            planId: 'premium-annually',
            amount: 2988,
          },
          enterpriseAnnually: {
            planId: 'enterprise-annually',
            amount: 10000,
          },
          enterpriseMonthly: {
            planId: 'enterprise-monthly',
            amount: 2000,
          },
          amazonBasicMonthly: {
            planId: 'price_1H2rZ0GddCycc7ZpodlEwUwa',
            amount: 69,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonBasicAnnual: {
            planId: 'price_1H2raJGddCycc7ZpqfOpsGYu',
            amount: 588,
            perMonthVideo: {
              limit: 25,
            },
          },
          amazonPremiumMonthly: {
            planId: 'price_1H2raqGddCycc7ZpYcJIat72',
            amount: 249,
          },
          amazonPremiumAnnual: {
            planId: 'price_1H2rbKGddCycc7Zp87Gy3ov8',
            amount: 2388,
          },
        },
      },
      GoogleAuth: {
        clientId: '271699968826-n516e2dad90ll393c7v5o25q740t8j6l.apps.googleusercontent.com',
      },
      AWS: {
        SiteAssets: 'https://d21kaqp8o0oh0c.cloudfront.net',
        cdnUrl: 'https://d21kaqp8o0oh0c.cloudfront.net',
        S3bucket: 'https://s3.amazonaws.com/videopeel-development',
        GateWayURL: 'https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/stage/process-video',
        fileUploadUrl: 'https://gd4215x8y7.execute-api.us-east-1.amazonaws.com/prod/files',
        attachmentsCloudfrontUrl: 'https://d3rn0qvp5ksu2g.cloudfront.net',
        S3bucketName: 'videopeel-development',
        fileUploadApiGateway: 'https://gd4215x8y7.execute-api.us-east-1.amazonaws.com/prod', // should be same as production
      },
      FACEBOOK: {
        isEnabled: true,
        appId: '2457067157728402',
      },
      trialPeriod: {
        days: 7,
      },
      projectId: 257755,
      projectKey: '913f712f693843d510f39b4293af316f',
      VideoPeelSupportLink: 'https://calendly.com/derek-217/vp-account-update',
      campaignIDs: ['k64bbg52', 'k7dmg3hc', 'k7dop0ti'],
      intercomAppID: 'uhfhkkts',
      campaignLimit: 2,
      errorBoundary: false,
      startVideoLink: 'https://www.youtube.com/embed/m5E9Q5cdD6E',
      pluginURL: 'https://plugin.storyportal.app',
      baseAppDomain: 'www.storyportal.app',
      appAlternateDomain: 'www.storyportal.app',
      subdomainBaseUrl: 'storyportal.app',
      perMonthVideo: 50,
      googleAnalyticsId: 'UA-112744776-3',
      nextGenMinimalCampaignTypeEnabled: true,
      mediaRecordsPerPageDefault: 25,
      campaignRecordsPerPageDefault: 25,
      maxCampaignsPerAccount: 50,
      pluginsV2Enabled: true,
      signInV2Enabled: true,
      pluginFontSizeEnabled: false,
      promoCodeEnabled: true,
      helpCenterLink: 'https://learn.videopeel.com/en/',
      captionHelpLink: 'https://learn.videopeel.com/en/articles/14485153-automated-captions',
      translationHelpLink: 'https://learn.videopeel.com/en/articles/14485272-automated-translations',
      rewardsHelpLink: 'https://learn.videopeel.com/en/articles/13403305-automated-rewards',
      contactSalesLink: 'https://www.videopeel.com',
      openMediaInPreviewModal: true,
      isAwinTrackingEnabled: false,
      vcpLiveExampleLink: 'https://app.videopeel.com/vc/cdtgx88l',
      vcpShareEnabled: false,
      termsAndConditionsLink: 'https://storyportal-assets.s3.amazonaws.com/StoryPortal+Terms.pdf',
      privacyPolicyLink: 'https://storyportal-assets.s3.amazonaws.com/StoryPortal+Privacy.pdf',
      companyName: 'StoryPortal',
      companyWebsite: 'https://www.storyportal.app',
      shareVideosLinkUrl: 'https://app.videopeel.com',
      signupLink: null,
      helpLink: null,
      inactivityLimit: 45 * 60 * 1000,
      modalTimeout: 2 * 60 * 1000,
    };
    break;
  default:
    throw new Error(`Missing or unsupported REACT_APP_ENV enviroment variable: ${env}`);
}

module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js